import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../pages/Home";
import AllFoods from "../pages/AllFoods";
import FoodDetails from "../pages/FoodDetails";
import Cart from "../pages/Cart";


import Login from "../pages/Login";


const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<Home />} />
      <Route path="/menu" element={<AllFoods />} />
      <Route path="/menu/:id" element={<FoodDetails />} />
      <Route path="/cart" element={<Cart />} />

      <Route path="/login" element={<Login />} />
      
      
    </Routes>
  );
};

export default Routers;
